export default {
	search: {
		title: 'Find Your Crew Ride',
		subtitle: 'Enter your flight number to find your transportation',
		placeholder: 'Enter Flight Number',
		button: 'Find Ride',
		slug: 'Crew Business is Our Business',
		imgAlt: '654 Global Logo',
		searchErrors: {
			empty: 'Flight number cannot be empty',
			noValidLinkOrExpired: 'This link has expired or is invalid. Please contact your dispatcher for a new access link.',
		},
	},
	tripInfo: {
		distance: 'Distance',
		duration: 'Duration',
		pickup: 'Pickup',
		dropoff: 'Drop off',
		pta: 'PTA',
		driverDetails: 'Driver Details',
		contactDispatcher: 'Contact Dispatcher',
		locateVehicle: 'Locate Vehicle',
	},
	tripCard: {
		imgAlt: 'Location Icon',
	},
	tripStatus: {
		'new': 'Planned',
		'in-route': 'In Route',
		'done': 'Done',
		'canceled': 'Canceled',
	},
	api: {
		error: 'An error occurred. Please try again later.',
	},
	noResults: {
		title: 'We are sorry, but there are currently no rides planned for flight #<flightNumber>.',
		button: 'Look For another Flight',
	},
	tripHeader: {
		distance: 'Distance',
		duration: 'Duration',
		pta: 'PTA',
		kilometers: 'km',
		minutesAbbreviation: 'min',
	},
	tripPoint: {
		drop: 'Drop Off',
		pick: 'Pickup',
	},
	tripDetailInfo: {
		contactDispatcher: 'Contact Dispatcher',
		locateVehicle: 'Locate Vehicle',
	},
	driverCard: {
		driverDetails: 'Driver Details',
	},
	driverLocation: {
		title: 'Locate Vehicle',
	},
};
